import type { ReactElement } from 'react'

import { render } from '@testing-library/react'
import { IntlProvider } from 'react-intl'

import { flattenMessages, getMessages, Locales } from '@acre/utils'

import messages from '../../intl/messagesBrokerCrm'

const flattenedMessages = flattenMessages(getMessages(messages, Locales.GB))

export default (tree: ReactElement) => {
  return render(
    <IntlProvider locale={Locales.GB} messages={flattenedMessages}>
      {tree}
    </IntlProvider>,
  )
}
